module.exports = __webpack_public_path__ + "static/scen-9-9d589a05b4408e1c178a0aca1c3a44a1.svg";